import { VueSelect, VueSelectOption } from '@ui-common/vue-select';

export default {
	data: () => ({ country: 'hungary' }),
	components: { VueSelect, VueSelectOption }
};
